// src/constants/collections.ts
export const COLLECTIONS = {
  USERS: "users",
  CHEFS: "chefs", // This might be deprecated, as chefs are in 'users'
  KITCHENS: "kitchens",
  MENUS: "menus",
  ORDERS: "orders", // This is for KitchenOrders ("child")
  PARENT_ORDERS: "parent_orders", // This is for ParentOrders ("parent")
  WALLETS: "wallets",
  CONFIG: "config",
  SUBSCRIPTIONS: "subscriptions",
  /** Canonical daily meal calendar (signup, My Tiffin, skip/pause, meal-lock, preGenerate). */
  DAILY_TIFFINS: "daily_tiffins",
  /** @deprecated Alias — use DAILY_TIFFINS. Points at daily_tiffins after collection unify. */
  DAILY_USER_TIFFINS: "daily_tiffins",
  ADMIN_DAILY_MENU: "admin_daily_menu",
  SPECIAL_ANNOUNCEMENTS: "special_announcements",
  DELIVERY_AGENTS: "delivery_agents", // This might be deprecated
  DELIVERY_RUNS: "delivery_runs",
};
